export const apiBaseUrl =
  import.meta.env.VITE_API_BASE_URL?.replace(/\/$/, "") || "http://localhost:8080";

export const r2MediaBaseUrl = import.meta.env.VITE_R2_MEDIA_BASE_URL?.replace(/\/$/, "") || "";

export const siteUrl = import.meta.env.VITE_SITE_URL || "https://moneymase.music";

